import { Stack } from '@mantine/core';
import { useTranslation } from 'next-i18next';

import { Select } from '@/components/Select';
import { NumberInputPanel } from '@/components/Theme/NumberInputPanel';
import { ResetButton } from '@/components/Theme/ResetButton';
import { ThemeControl } from '@/components/Theme/ThemeControl';
import { ThemeItemSection } from '@/components/Theme/ThemeItemSection';
import { useWidgetStyle } from '@/utils/useWidgetStyle';
import { FlexSectionDirection } from '@/widgets/FlexSection/types';
import { useContentObject } from '@/widgets/_components/ContentObjectProvider';

const directionData = ['row', 'column'];

export const DEFAULT_MARGIN_START = 0;
export const DEFAULT_MARGIN_END = 0;
export const DEFAULT_DIRECTION = FlexSectionDirection.column;
export const DEFAULT_GAPS = 16;

export function DropzoneConfig() {
  const { t } = useTranslation('components', { keyPrefix: 'theme.settings' });

  const { id, document } = useContentObject();

  const [direction, setDirection] = useWidgetStyle<string>(document, id, 'dropzoneDirection');
  const [gap, setGap] = useWidgetStyle<number>(document, id, 'dropzoneGap');
  const [marginEnd, setMarginEnd] = useWidgetStyle<number>(document, id, 'dropzoneMarginEnd');
  const [marginStart, setMarginStart] = useWidgetStyle<number>(document, id, 'dropzoneMarginStart');

  return (
    <ThemeItemSection label={t('dropzone')}>
      <Stack>
        <NumberInputPanel
          label={t('marginStart')}
          value={marginStart ?? DEFAULT_MARGIN_START}
          onChange={setMarginStart}
          ResetButton={
            marginStart !== DEFAULT_MARGIN_START && <ResetButton onClick={() => setMarginStart(DEFAULT_MARGIN_START)} />
          }
        />
        <NumberInputPanel
          label={t('marginEnd')}
          value={marginEnd ?? DEFAULT_MARGIN_END}
          onChange={setMarginEnd}
          ResetButton={
            marginEnd !== DEFAULT_MARGIN_END && <ResetButton onClick={() => setMarginEnd(DEFAULT_MARGIN_END)} />
          }
        />
        <ThemeControl label={t('direction')}>
          <Select data={directionData} value={direction} onChange={value => value && setDirection(value)} />
          {direction !== DEFAULT_DIRECTION && <ResetButton onClick={() => setDirection(DEFAULT_DIRECTION)} />}
        </ThemeControl>
        <NumberInputPanel
          label={t('gaps')}
          value={gap ?? DEFAULT_GAPS}
          onChange={value => setGap(value)}
          ResetButton={gap != DEFAULT_GAPS && <ResetButton onClick={() => setGap(DEFAULT_GAPS)} />}
        />
      </Stack>
    </ThemeItemSection>
  );
}
